import { EKwikUIProgressCircleSize } from "./progress-circle.definitions";

export const DEFAULT_VALUES = {
  color: "var(--tui-primary)",
  id: "progress_circle",
  max: 2,
  size: EKwikUIProgressCircleSize.M,
  value: 1
};

export const VALIDATE_KEY_VALUES = {
  color: true,
  max: true,
  size: true,
  value: true
};
